import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const PassesView = angular
  .module('acme.view.application.passes', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.passes.list',
    'acme.view.application.passes.create',
    'acme.view.application.passes.detail',
    'acme.view.application.passes.controllers',
    'acme.view.application.dataGrid.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const passes = {
      name: 'application.passes',
      url: '/passes',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'PassesController',
          templateUrl: 'views/application/views/passes/passes.tpl.html',
        },
      },
    };

    $stateProvider.state(passes);
  }).name;
